<template>
    <span class="i-layout-header-trigger i-layout-header-trigger-min">
        <!--  -->
        <span class="system-title">{{$t('page.common.systemTitle')}}</span>
            
        <Dropdown :trigger="isMobile ? 'click' : 'hover'" class="i-layout-header-user" :class="{ 'i-layout-header-user-mobile': isMobile }" @on-click="handleClick">
            
            <Avatar size="small" :src="info.avatar" v-if="info.avatar" />
            <span class="i-layout-header-user-name" v-if="!isMobile">{{ info.name }}</span>
            <DropdownMenu slot="list">
                <!-- 个人信息 -->
                <i-link :to="'/dashboard/user/userInfo/'+info.id">
                    <DropdownItem>
                        <Icon type="ios-contact-outline" />
                        <span>{{ $t('basicLayout.user.center') }}</span>
                    </DropdownItem>
                </i-link>
                <!-- lhj 删除 v-ab-btn-rights:change_password --> <!-- 修改密码 -->
                <i-link v-if="!isLdapUser" :to="'/dashboard/user/updatePassword/'+info.id" >
                    <DropdownItem>
                        <Icon type="ios-settings-outline" />
                        <span>{{ $t('basicLayout.user.setting') }}</span>
                    </DropdownItem>
                </i-link>
                <DropdownItem v-if="info.orgList||info.orgList.length<=1">
                 <Icon type="ios-people-outline"></Icon>
                 	<span v-if="info.currentOrg">{{ info.currentOrg.groupName }}</span>
                 	<span v-if="!info.currentOrg" style="color: #c3cbd6	">{{$t('page.user.noOrg')}}	</span>
                  	
                </DropdownItem>
                 <!-- 切换当前组织 --> <!-- 暂不需要 -->
                 <!-- <Dropdown placement="right-start" style="display: block;" v-if="info.orgList&&info.orgList.length>1">
	                <DropdownItem>
	                       <Icon type="ios-people-outline"></Icon>
	                       <Tooltip v-if="info.currentOrg" :content="info.currentOrg.pathName" placement="top-end">
				                <span>{{  info.currentOrg.groupName }}</span>
				            </Tooltip>
	                    	
	                    	<Icon type="ios-arrow-forward"></Icon>
	                </DropdownItem>
                   
	                <DropdownMenu slot="list" >
	                	<DropdownItem><span style="font-size: 14px;font-weight: bold;color: rgb(70, 76, 91);">{{ $t('basicLayout.user.changeOrg') }}</span></DropdownItem>
	                    <DropdownItem v-for="org in  info.orgList" v-show="org.groupId !== info.currentOrg.groupId">
	                    		<Tooltip  :content="org.pathName" placement="top">
                                    <a @click="changeOrg(org)">
                                        <Icon type="ios-swap"></Icon> 
                                            <span> {{org.groupName}}</span>
                                    </a> 
				            	</Tooltip>
	                    </DropdownItem>
	                </DropdownMenu>
	            </Dropdown> -->
                <DropdownItem divided name="logout">
                    <Icon type="ios-log-out" />
                    <span>{{ $t('basicLayout.user.logOut') }}</span>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    </span>
</template>
<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'iHeaderUser',
        computed: {
            ...mapState('admin/user', [
                'info'
            ]),
            ...mapState('admin/layout', [
                'isMobile',
                'logoutConfirm'
            ])
        },
        data () {
            return {
                isLdapUser:true,
            }
        },
        created(){
            setTimeout(() => {
                this.abTools.getUserDetail(this.$store.state.admin.user.info.id,data=>{
                    if(data.from!='LDAP'){
                        this.isLdapUser = false;
                    }
                });
            }, 2000);
        },
        mounted () {
            console.log("store======",this.$store)
            // this.handleClick('logout');
        },
        methods: {
            ...mapActions('admin/account', [
                'logout'
            ]),
            ...mapActions('admin/page', [
                'closeAll'
            ]),
            handleClick (name) {
                if (name === 'logout') {
                	this.logout({
                        confirm: this.logoutConfirm,
                        vm: this
                    });
                }
            },
            changeOrg(org){
            	this.abHttpUtil.postForm("/userResource/changeOrg?orgId="+org.groupId,{}).then((data)=>{
            		location=location;        		
            	})
            	
            }
        }
    }
</script>
